module.exports = __webpack_public_path__ + "static/media/ptiqcs-logo-symbol.226de88b.png";